/**
 * Shared constants for the Commands tab.
 * Presentation styles live in CSS modules; console height is preserved here.
 */

/** Distinct accent for “send command” actions (separate from selection blue). */
export const COMMAND_EXECUTE_ACCENT = '#0D9488';
export const COMMAND_EXECUTE_ACCENT_HOVER = '#0F766E';

/**
 * Console height is intentional product UX — do not restyle the console.
 * Only outer placement/width may respond to the page layout.
 */
export const CONSOLE_DESKTOP_HEIGHT = 420;
export const CONSOLE_MOBILE_HEIGHT = 'min(320px, 45vh)';
